// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"108":"3f072cc4","119":"cc8707a3","747":"b442d1ef","958":"40243a6b"}[chunkId] + ".chunk.css";
};